import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LayoutComponent } from "./layout/layout.component";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
// import { RewardsDialogService } from './core/services/rewards.dialog.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent, TourMatMenuModule, MatCardModule, MatIconModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    // private dialogService: RewardsDialogService
  ) { }

  title = ' | Safety Knights';
  public tourService = inject(TourService);
  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const title = data['title'];
        const description = data['content'];
        // this.dialogService.initializeDialog();

        if (title) {
          this.titleService.setTitle(title || `Safety Knights`);
        }

        if (description) {
          this.metaService.updateTag({
            name: 'description',
            content: description
          });
        }
      });
  }
}
